import React from 'react'
import {
  Button,
  Input,
  Modal,
  Col,
  Row,
  Table,
  Menu,
  Space, message, Pagination, Tag, Tabs, ConfigProvider
} from 'antd'
import {BellOutlined} from '@ant-design/icons'
import './index.less'
import zhCN from "antd/es/locale/zh_CN";
import {getHistoryList, getActivityMainList, getActivityMainDetail, getActivityMainProducts, getActivityMainDelete} from "../../constants/api";
import {removeToken} from "../../utils/cookie";

import {COMMON_ROUTER} from "../../constants";

const {Search} = Input;
const {CheckableTag} = Tag;
const {TabPane} = Tabs;

export default class Activitys extends React.Component {

  constructor() {
    super();
  }

  state = {
    templateId: '',//模板ID

    platformType: null, //总店类型

    activitys: [],
    current: 1,
    total: 0,
    pageSize: 10,
    selectedTag: '全部',//状态value
    selectedStatus: 0,

    activityIdOption: 0,
    onDeleteVisible: false, //结束活动
    visible: false,//详情显示隐藏
    detailSelectedType: 0,//类型

    //活动详情
    activityChildType: 0,
    activityDesc: '',
    activityId: 0,
    activityName: '',
    activityType: 0,
    activityTypeName: '',
    beginDate: '',
    closeTime: '',
    createTime: '',
    deliveryType: 0,
    endDate: '',
    openTime: '',
    ruleInfo: '',
    updateTime: '',
    userType: 0,
    weekDay: '',
    weekDayStr: '',
    storeUserDayLimit: -1,
    storeUserLimit: -1,

    activityProducts: [],
    currentP: 1,
    totalP: 0,

    logVisible: false,//log弹窗
    logList: [],
    logTotal: 0,
    logCurrent: 1,
    logPagesize: 10,
  }

  componentDidMount() {
    this.getTemplateId()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType')
    console.log(platformType)
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType
      }, () => {
        this.searchActivitys(1, templateId, '', 0, 10, 0);
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  searchActivitys(current, templateId, name, type, size, childType) {
    const _this = this;
    getActivityMainList({
      id: templateId,
      activityName: name,
      activityType: type,
      activityChildType: childType,
      pageIndex: current,
      pageSize: size,
      sortName: "",
      sortType: "descending",
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            activitys: data.data.records,
            total: data.data.total
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ACTIVITY_LIST, {
    //   id: templateId,
    //   activityName: name,
    //   activityType: type,
    //   activityChildType: childType,
    //   pageIndex: current,
    //   pageSize: size,
    //   sortName: "",
    //   sortType: "descending",
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log('活动列表');
    //     console.log(data.data);
    //     _this.setState({
    //       activitys: data.data.records,
    //       total: data.data.total
    //     });
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  onChangePage(page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({current: page}, () => {
      this.searchActivitys(page, this.state.templateId, '', 0, this.state.pageSize, 0)
    })
  }
  onChangePageSize(page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({current: page, pageSize: pageSize}, () => {
      // this.searchActivitys(page, this.state.tempCategoryId, '', '', pageSize)
    })
  }

  handleTagChange(tag, checked) {
    console.log(tag);
    console.log(checked);
    this.setState({selectedTag: tag})
    if (tag === '全部') {
      this.setState({selectedStatus: 0, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 0, this.state.pageSize)
      })
    } else if (tag === '单品直降') {
      this.setState({selectedStatus: 1, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 2, this.state.pageSize, 0)
      })
    } else if (tag === '品类满减') {
      this.setState({selectedStatus: 2, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 2, this.state.pageSize)
      })
    } else if (tag === '第N件特价') {
      this.setState({selectedStatus: 3, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 3, this.state.pageSize)
      })
    } else if (tag === 'N选1') {
      this.setState({selectedStatus: 4, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 32, this.state.pageSize, 2)
      })
    } else if (tag === '买N增M') {
      this.setState({selectedStatus: 5, current: 1}, () => {
        this.searchActivitys(1, this.state.templateId, '', 5, this.state.pageSize)
      })
    }
  }

  //结束活动弹窗
  onShowModal = (activityId) => {
    this.setState({
      onDeleteVisible: true,
      activityIdOption: activityId,
    })
  }
  //确认结束
  onHandleOk = () => {
    this.endActivity();
  }
  onHandleCancel = () => {
    this.setState({
      onDeleteVisible: false
    })
  }
  endActivity = () => {
    getActivityMainDelete({
      activityId: this.state.activityIdOption,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onDeleteVisible: false
          }, () => {
            message.success('操作成功')
            this.searchActivitys(this.state.current, this.state.templateId, '', 0, this.state.pageSize);
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onDeleteVisible: false
          }, () => {
            message.error('操作失败')
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ACTIVITY_DEL, {
    //   activityId: this.state.activityIdOption,
    //   templateId: this.state.templateId
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onDeleteVisible: false
    //       }, () => {
    //         message.success('操作成功')
    //         this.searchActivitys(this.state.current, this.state.templateId, '', 0, this.state.pageSize);
    //       })
    //     } else {
    //       this.setState({
    //         onDeleteVisible: false
    //       }, () => {
    //         message.error('操作失败')
    //       })
    //     }
    //   }
    // })
  }

  //展示详情弹窗
  showModal = (activityId) => {
    this.setState({
      visible: true,
      activityIdOption: activityId,
      detailSelectedType: 0
    }, () => {
      //查询活动详情
      this.fetchActivityInfo(activityId);
    });
  };

  //查询信息
  fetchActivityInfo(activityId) {
    const _this = this;
    getActivityMainDetail({
      templateId: this.state.templateId,
      activityId: activityId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code == 0) {
          _this.setState({
            activityChildType: data.data.activityChildType,
            activityDesc: data.data.activityDesc,
            activityId: data.data.activityId,
            activityName: data.data.activityName,
            activityType: data.data.activityType,
            activityTypeName: data.data.activityTypeName,
            beginDate: data.data.beginDate,
            endDate: data.data.endDate,
            createTime: data.data.createTime,
            updateTime: data.data.updateTime,
            deliveryType: data.data.deliveryType,
            ruleInfo: data.data.ruleInfoName,
            userType: data.data.userType,
            weekDay: data.data.weekDay,
            openTime: data.data.openTime,
            closeTime: data.data.closeTime,
            storeUserDayLimit: data.data.storeUserDayLimit,
            storeUserLimit: data.data.storeUserLimit
          })

          if (data.data.weekDay == '0,1,2,3,4,5,6' || data.data.weekDay == '1,2,3,4,5,6,0') {
            _this.setState({
              weekDayStr: '整周'
            })
          } else {
            let s = data.data.weekDay.replace('0', '周日')
                .replace('0', '周日')
                .replace('1', '周一')
                .replace('2', '周二')
                .replace('3', '周三')
                .replace('4', '周四')
                .replace('5', '周五')
                .replace('6', '周六')
            let weekArry = s.split(',')
            let week = ''
            weekArry.map((item, index) => {
              week = week + item + ' '
            })
            _this.setState({
              weekDayStr: week
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })



    // axiosD.post(API_ACTIVITY_INFO, {
    //   templateId: this.state.templateId,
    //   activityId: activityId,
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code == '0') {
    //       _this.setState({
    //         activityChildType: data.data.activityChildType,
    //         activityDesc: data.data.activityDesc,
    //         activityId: data.data.activityId,
    //         activityName: data.data.activityName,
    //         activityType: data.data.activityType,
    //         activityTypeName: data.data.activityTypeName,
    //         beginDate: data.data.beginDate,
    //         endDate: data.data.endDate,
    //         createTime: data.data.createTime,
    //         updateTime: data.data.updateTime,
    //         deliveryType: data.data.deliveryType,
    //         ruleInfo: data.data.ruleInfoName,
    //         userType: data.data.userType,
    //         weekDay: data.data.weekDay,
    //         openTime: data.data.openTime,
    //         closeTime: data.data.closeTime,
    //         storeUserDayLimit: data.data.storeUserDayLimit,
    //         storeUserLimit: data.data.storeUserLimit
    //       })
    //
    //       if (data.data.weekDay == '0,1,2,3,4,5,6' || data.data.weekDay == '1,2,3,4,5,6,0') {
    //         _this.setState({
    //           weekDayStr: '整周'
    //         })
    //       } else {
    //         let s = data.data.weekDay.replace('0', '周日')
    //           .replace('0', '周日')
    //           .replace('1', '周一')
    //           .replace('2', '周二')
    //           .replace('3', '周三')
    //           .replace('4', '周四')
    //           .replace('5', '周五')
    //           .replace('6', '周六')
    //         let weekArry = s.split(',')
    //         let week = ''
    //         weekArry.map((item, index) => {
    //           week = week + item + ' '
    //         })
    //         _this.setState({
    //           weekDayStr: week
    //         })
    //       }
    //     }
    //
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  //查询信息商品
  fetchActivityProducts(activityId, current) {
    const _this = this;
    getActivityMainProducts({
      id: activityId,
      pageIndex: current,
      pageSize: 10,
      sortName: "string",
      sortType: "descending"
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            activityProducts: data.data.records,
            totalP: data.data.total
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ACTIVITY_INFO_PRODUCT, {
    //   id: activityId,
    //   pageIndex: current,
    //   pageSize: 10,
    //   sortName: "string",
    //   sortType: "descending"
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log('活动商品列表');
    //     console.log(data.data);
    //     _this.setState({
    //       activityProducts: data.data.records,
    //       totalP: data.data.total
    //     });
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  onChangePageP(page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({currentP: page}, () => {
      this.fetchActivityProducts(this.state.activityIdOption, page)
    })
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  /**
   * @Description: 跳转到添加活动
   * @Author Jiang
   * @Date 2020/9/5 8:23
   */
  toAddActivity = () => {

    this.props.history.push({
      pathname: COMMON_ROUTER + "/activitys/add-activity",
      state: {
        templateId: this.state.templateId,
        platformType: this.state.platformType
      }
    })
  }

  toEditActivity = (id) => {
    this.props.history.push({
      pathname: COMMON_ROUTER + "/activitys/edit-activity",
      state: {
        activityId: id,
        templateId: this.state.templateId,
        platformType: this.state.platformType
      }
    })
  }

  callback(key) {
    console.log(key);
    if (key == '0') {
      this.setState({detailSelectedType: key}, () => {
        this.fetchActivityInfo(this.state.activityIdOption)
      })
    } else if (key == '1') {
      this.setState({detailSelectedType: key}, () => {
        this.fetchActivityProducts(this.state.activityIdOption, 1)
      })
    }
  }

  handleMenuClick = (e)=> {
    console.log('click', e.key);
    if (e.key == 1) {
      this.toAddActivity()
    } else if (e.key == 2) {

    } else if (e.key == 3) {

    } else if (e.key == 4) {

    } else if (e.key == 5) {

    }
  }

  getLogs = (current, size) => {
    const _this = this
    getHistoryList({
      pageIndex: current,
      pageSize: size,
      sortName: "",
      sortType: "descending",
      id: _this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          console.log(data.data)
          console.log(data.data.records)
          _this.setState({
            logList: data.data.records,
            logTotal: data.data.total
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_LOG_LIST, {
    //   pageIndex: current,
    //   pageSize: size,
    //   sortName: "",
    //   sortType: "descending",
    //   id: _this.state.templateId
    // })
    //     .then(function (response) {
    //       let data = response.data;
    //       if (data.code === 0) {
    //         console.log(data.data)
    //         console.log(data.data.records)
    //         _this.setState({
    //           logList: data.data.records,
    //           logTotal: data.data.total
    //         })
    //       } else {
    //         message.error(data.msg, 1)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
  }
  showLog = () => {
    this.setState({
      logVisible: true,
    }, ()=>{
      this.getLogs(1, this.state.logPagesize)
    });
  }
  onHandleLogOk = (e) => {
    this.setState({
      logVisible: false,
    });
  }
  onHandleLogCancel = (e) => {
    this.setState({
      logVisible: false,
    });
  }
  onChangePageLog = (page, pageSize) => {
    console.log('-------------')
    console.log(page)
    this.setState({logCurrent: page}, ()=>{
      this.getLogs(page, this.state.logPagesize)
    })
  }

  onChangeSizeLog = (current, size) => {
    this.setState({logPagesize: size})
  }

  render() {
    const columnsActivitys = [
      {
        title: '活动名称',
        dataIndex: 'activityName',
        render: (text, record) => (
          <div style={{display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
            <span>{record.activityName}</span>
            <span style={{color: '#868686'}}>ID:{record.activityId}</span>
          </div>
        ),
      },
      {
        title: '活动类型',
        dataIndex: 'activityTypeName',
      },
      {
        title: '活动描述',
        dataIndex: 'activityDesc',

      },
      {
        title: '活动规则',
        dataIndex: 'ruleInfoName',
      },
      {
        title: '活动时间',
        dataIndex: 'beginDate',
        render: (text, record) => (
          <div style={{display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
            <span>开始：{record.beginDate}</span>
            <span>结束：{record.endDate}</span>
          </div>
        ),
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
      },
      {
        title: '状态',
        dataIndex: 'statusName',
      },
      {
        title: '操作',
        dataIndex: 'option',
        render: (text, record) => (
          <Space size="middle">
            <a onClick={this.showModal.bind(this, record.activityId)}>详情</a>
            <a onClick={this.toEditActivity.bind(this, record.activityId)}>复制活动</a>

            {
              (record.statusName == '已删除' || record.statusName == '已结束') ? null :
                  <a style={{color: "#eb2509"}} onClick={this.onShowModal.bind(this, record.activityId)}>结束活动</a>
            }
          </Space>
        ),
      },
    ];
    const columnsActivitysProduct = [
      {
        title: '商品',
        dataIndex: 'product',
        render: (text, record) => (
            <div>
              {
                <div
                    style={{height: 40, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                  <img style={{width: 40, height: 40}} src={record.imageUrl}/>
                  <div style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: "5px",
                  }}>{record.productName}
                  </div>
                </div>
              }
            </div>
        ),
      },
      {
        title: '条形码',
        dataIndex: 'barCode',
      },
      {
        title: '活动当天库存',
        dataIndex: 'dayStock',
      },
      {
        title: '价格',
        dataIndex: 'price',
        render: (text, record) => (
          <div>
            ￥{record.price}
          </div>
        ),
      },
      {
        title: '活动价',
        dataIndex: 'specialPrice',
        render: (text, record) => (
            <div>
              ￥{record.specialPrice}
            </div>
        ),
      },
    ];

    const columnsLogs = [
      {
        title: "同步ID",
        dataIndex: 'dataSynchroHistoryId',
        width: 100
      },
      {
        title: "操作类型",
        dataIndex: 'operationName',
        width: 160,
        // ellipsis: true
      },
      {
        title: "操作内容",
        dataIndex: 'operationContent',
        width: 200,
        // ellipsis: true
      },
      {
        title: "状态码",
        dataIndex: 'dataStatusName',
        width: 100,
        ellipsis: true
      },
      {
        title:"开始时间",
        dataIndex: 'addTime',
        width: 160,
        ellipsis: true
      },
      {
        title:"结束时间",
        dataIndex: 'updateTime',
        width: 160,
        ellipsis: true
      },
      {
        title: "操作结果",
        dataIndex: 'operationResult',
        // width: 800,
        // ellipsis: true
      }
    ];
    let {activitys, activityProducts} = this.state;

    const formItemLayout = {
      labelCol: {
        xs: 24,
        sm: 4
      },
      wrapperCol: {
        xs: 24,
        sm: 12
      }
    }

    // const tagsData = ['全部', '单品直降', '品类满减', '第N件特价', 'N选1', '买N增M'];
    const tagsData = ['全部', '单品直降', 'N选1'];

    const menuCreate = (
        <Menu onClick={this.handleMenuClick}>
          <Menu.Item key="1">单品直降</Menu.Item>
          <Menu.Item key="2">品类满减</Menu.Item>
          <Menu.Item key="3">第N件特价</Menu.Item>
          <Menu.Item key="4">N选1</Menu.Item>
          <Menu.Item key="5">买N赠M</Menu.Item>
        </Menu>
    );
    return (
      <div style={{width: "100%"}}>
        <Row className="container">
          <Col span="24" className="goods-right">
            <div className="goods-option">
              <div>
                <span>类型：</span>
                {
                  tagsData.map(tag => (
                    <CheckableTag
                      style={{height: '30px', lineHeight: '30px'}}
                      key={tag}
                      checked={this.state.selectedTag === tag}
                      onChange={checked => this.handleTagChange(tag, checked)}
                    >
                      {tag}
                    </CheckableTag>))
                }
              </div>

              <div className="right">
                <div style={{marginRight: '40px', marginLeft: '40px'}} onClick={this.showLog}>
                  <BellOutlined style={{ fontSize: '14px', color: '#0b68d4' }} />
                  <a>任务进度</a>
                </div>
                <Search style={{width: '300px'}} placeholder="输入活动名称查询"
                        onSearch={value => {
                          this.setState({
                            current: 1
                          }, () => {
                            this.searchActivitys(1, this.state.templateId, value, this.state.selectedType, this.state.pageSize)
                          })
                        }} enterButton/>
                <span style={{marginLeft: 8}}>
                  {/*<Dropdown overlay={menuCreate}>*/}
                    <Button type="primary" shape="round" onClick={this.toAddActivity.bind(this)}>
                                新建活动
                      {/*<DownOutlined />*/}
                            </Button>
                  {/*</Dropdown>*/}
                </span>
              </div>
            </div>
            <Table rowKey="activityId"
                   columns={columnsActivitys}
                   pagination={false}
                   dataSource={activitys}/>
            <ConfigProvider locale={zhCN}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", padding: "0 20px 0 0"}}>
              <Pagination style={{marginTop: 20}} showQuickJumper={true} showSizeChanger={true} onShowSizeChange={this.onChangePageSize.bind(this)}
                          current={this.state.current} pageSize={this.state.pageSize} total={this.state.total}
                          onChange={this.onChangePage.bind(this)}/>
            </div>
            </ConfigProvider>
          </Col>
        </Row>

        <Modal
          title='活动详情'
          visible={this.state.visible}
          width={'70%'}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确认"
          cancelText="取消"
        >
          <div style={{width: '100%', height: '600px'}}>
            <Tabs activeKey={this.state.detailSelectedType.toString()} onChange={this.callback.bind(this)}>
              <TabPane tab="活动信息" key="0">
                <div className="detail">
                  <span style={{marginLeft: 0, color: '#868686'}}>基本信息</span>
                  <span style={{marginLeft: 50, color: '#868686'}}>创建时间：<span
                    style={{color: '#000000'}}>{this.state.createTime}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>活动名称：<span
                    style={{color: '#000000'}}>{this.state.activityName}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>活动描述：<span
                    style={{color: '#000000'}}>{this.state.activityDesc}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>活动日期：
                    <span
                      style={{color: '#000000'}}>{this.state.beginDate + ' - ' + this.state.endDate + ' ' + this.state.weekDayStr}</span>
                  </span>
                  <span style={{marginLeft: 50, color: '#868686'}}>生效时段：
                    <span style={{color: '#000000'}}>{this.state.openTime + ' - ' + this.state.closeTime}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>订单类型：<span style={{color: '#000000'}}>{
                    this.state.deliveryType == 1 ? '配送' :
                      this.state.deliveryType == 2 ? '自提' :
                        this.state.deliveryType == 3 ? '配送+自提' : '配送'
                  }</span></span>
                  <span style={{marginLeft: 0, marginTop: 10, color: '#868686'}}>活动规则</span>
                  <span style={{marginLeft: 50, color: '#868686'}}>顾客类型：
                    <span style={{color: '#000000'}}>{this.state.userType == 0 ? '全部顾客' :
                      this.state.userType == 2 ? '门店新用户, 第N件特价填0(第N件只有全部顾客)' :
                        this.state.userType == 3 ? '指定顾客' : ''}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>活动类型：<span
                    style={{color: '#000000'}}>{this.state.activityTypeName}</span></span>
                  <span style={{marginLeft: 50, color: '#868686'}}>每人每店每日限购：
                    <span style={{color: '#000000'}}>{
                      this.state.storeUserDayLimit == -1 ? '每件商品，每人每日不限购' : '每件商品，每人每日可购买' + this.state.storeUserDayLimit + '件'
                    }</span>
                  </span>
                  {
                    this.state.activityType == 32 ?
                        <span style={{marginLeft: 50, color: '#868686'}}>活动规则：<span
                            style={{color: '#000000'}}>{this.state.ruleInfo}</span></span>
                        :
                        null
                  }
                </div>
              </TabPane>
              <TabPane tab="商品列表" key="1">
                <Table rowKey="id"
                       columns={columnsActivitysProduct}
                       scroll = {{y:'420px'}}
                       pagination={false}
                       dataSource={activityProducts}/>
                <Pagination style={{marginTop: 20}} showQuickJumper={true} showSizeChanger={false}
                            current={this.state.currentP} pageSize={10} total={this.state.totalP}
                            onChange={this.onChangePageP.bind(this)}/>
              </TabPane>
            </Tabs>
          </div>
        </Modal>

        <Modal
          visible={this.state.onDeleteVisible}
          onOk={this.onHandleOk.bind(this)}
          onCancel={this.onHandleCancel.bind(this)}
          okText="确认"
          cancelText="取消"
        >
          确定将活动结束吗？
        </Modal>

        <Modal
            title="推送日志"
            width={'80%'}
            visible={this.state.logVisible}
            onOk={this.onHandleLogOk.bind(this)}
            onCancel={this.onHandleLogCancel.bind(this)}
            okText="确认"
            cancelText="取消"
            footer={null}
        >
          <div style={{width: '100%', padding: '0 0 30px 0'}}>
            <Table
                rowKey={'dataSynchroHistoryId'}
                dataSource={this.state.logList}
                columns={columnsLogs}
                pagination={false}
                size='default'
            />
            <ConfigProvider locale={zhCN}>
              <div style={{float: 'right'}}>
                <Pagination style={{marginTop: 5}} showQuickJumper={true} onShowSizeChange={this.onChangeSizeLog}
                            current={this.state.logCurrent} pageSize={this.state.logPagesize} total={this.state.logTotal}
                            onChange={this.onChangePageLog}/>
              </div>
            </ConfigProvider>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/activitys/index.js